export default (date) => {
    if (date) {
        let d = `${date.slice(8, 10)}/${date.slice(5, 7)}/${date.slice(0, 4)}`
        return d;
    }
}